import { useAssessmentContext } from '@/libs/context/AssessmentContext';
import styles from './Assessment.module.css';
export function AssessmentConfirmBox() {
    const { isConfirm, setIsConfirm } = useAssessmentContext();
    return <div className={`${styles.showConfirm} ${styles.active} ${styles.selected}`}>
        <div className={styles.Assessment_formPopup}>
            <h3 className="font25 fontsm16 text666 mb30">Are you still interested in proceeding with your Self-Assessment? </h3>
            <div className={styles.button_cofirm}>
                <button className={`btn btn-primary ${styles.submitOtp}`} onClick={() => setIsConfirm!(!isConfirm)}>Continue</button>
                <button className={`btn btn-primary ${styles.submitOtp} ${styles.continueBtn}`} onClick={() => setIsConfirm!(!isConfirm)}>Fresh Start</button>
            </div>
        </div>
    </div>
}